abstract class OfflineProtomapsService {}

export { OfflineProtomapsService };
